import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'vb_fliesen',
} as IModuleProps;
